export default "__VITE_ASSET__mnvE8dXf__"